import {
  EntityIdentificationType,
  EntityListResponse,
  EntityListTypeName,
  ProductListResponse,
} from '@ydistri/api-sdk';

export interface ArchivableAdministrationItem {
  isArchived: boolean;
}

export type SelectionType = EntityIdentificationType | EntityListTypeName;

export interface ReactSelectType<T> {
  label: string;
  value: T;
}

export enum ActiveScreenType {
  NO_SELECTION = 'no-selection',
  EDIT = 'edit',
  DETAIL = 'detail',
  VALIDATION = 'validation',
  DONE = 'done',
}

export const onlyActive = <T extends ArchivableAdministrationItem>(targetLists: T[]): T[] => {
  return targetLists.filter(item => !item.isArchived);
};

export const getArchivedItemsCount = (items: ArchivableAdministrationItem[]): number => {
  return items.reduce((previousValue, item) => {
    if (item.isArchived) {
      return previousValue + 1; //do not use post increment here as it first returns a value and then increments it
    } else {
      return previousValue;
    }
  }, 0);
};

export const getArchivedStateSorter =
  <T extends ArchivableAdministrationItem>(defaultSorter: (l: T, r: T) => number) =>
  (left: T, right: T): number => {
    if ((left.isArchived && right.isArchived) || (!left.isArchived && !right.isArchived)) {
      return defaultSorter(left, right);
    } else {
      return left.isArchived ? 1 : -1;
    }
  };

export const nameSorter = <T extends ProductListResponse | EntityListResponse>(
  left: T,
  right: T,
): number => {
  if (left.name && right.name) {
    return left.name.localeCompare(right.name);
  } else {
    if (left.name) {
      return -1;
    } else {
      return 1;
    }
  }
};

export const lastUpdatedAtSorter = <T extends ProductListResponse | EntityListResponse>(
  left: T,
  right: T,
): number => {
  if (left.lastUpdatedAt && right.lastUpdatedAt) {
    return right.lastUpdatedAt.localeCompare(left.lastUpdatedAt);
  } else {
    if (left.lastUpdatedAt) {
      return 1;
    } else {
      return -1;
    }
  }
};
